import React from 'react';

import './RecurringBuyFundEditor.scss';

import DayGrid from './DayGrid';
import MonthGrid from './MonthGrid';
import RecurringBuyFundEditorWrapper from './RecurringBuyFundEditorWrapper';
import SingleSelectionGrid from '../../Shared/SelectableGrid/SingleSelectionGrid';
import {
  TRANSFER_DAYS,
  TRANSFER_MONTHS,
} from '../../../redux/modules/shoppingCart/shoppingCart.module';
import { selectableDays, selectableMonths } from '../../../settings/settings';

const ActivePlusRecurringBuyFundEditor = (props) => {
  const {
    actions: { openModal, updateDaySelection, updateMonthSelection },
    fund: { agreementID, BPID, transferDays, transferMonths },
  } = props;

  /*
  TODO
  This is not ideal, since the day and month selection are updated together every time,
  even if the month selection didn't change.  However, without changing this to a stateful
  component, or upgrading react to be able to use hooks, this is the best we can do, as it
  is not a large performance impact.
  */
  function updateDaysAndMonth(agreementID, selected) {
    updateDaySelection(agreementID, selected, TRANSFER_DAYS, BPID);
    updateMonthSelection(
      agreementID,
      selectableMonths,
      TRANSFER_MONTHS,
      BPID,
      true
    );
  }

  return (
    <RecurringBuyFundEditorWrapper
      {...props}
      MonthGrid={
        <MonthGrid
          selectableMonths={[]}
          onSelect={null}
          selectAll={false}
          selectedMonths={transferMonths}
          footer="Every Month"
        />
      }
      DayGrid={
        <DayGrid
          openModal={openModal}
          SelectionGrid={SingleSelectionGrid}
          selectableDays={selectableDays}
          onSelect={(selected) => updateDaysAndMonth(agreementID, selected)}
          selectAll={false}
          selectedOptions={transferDays}
          selectLimit={1}
          limitText="Max: 1 day per month"
        />
      }
    />
  );
};

export default ActivePlusRecurringBuyFundEditor;
